export const THEME_PREVIEW = 'Theme';
export const NATIVE_PRODUCT_PREVIEW = 'Native';
export const NETWORK_PRODUCT_PREVIEW = 'Network';
export const MOCK_USER_ID = '00000000-0000-0000-0000-000000000001';
export const MOCK_COMPANY_ID = '00000000-0000-0000-0000-000000000002';
